import HomeCatLayout from '../components/organisms/HomeCatLayout';
import { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config';

const HomeCats = () => {
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMsg, setSnackMsg] = useState('');
  const [trigger, setTrigger] = useState(0);
  const [homecats, setHomeCats] = useState([]);
  const [snackBarType, setSnackBarType] = useState('success');

  useEffect(() => {
    const getAcc = new FormData();
    getAcc.append('auth', localStorage.getItem('token'));
    axios.post(config.HOMECAT_API, getAcc).then(output => {
      setHomeCats(output?.data?.response?.homecat);
    });
  }, [trigger]);

  const createNewAcc = () => {
    const nameField = document.getElementById('newAccName');
    const userField = document.getElementById('newAccUser');
    const passField = document.getElementById('newAccPassword');
    if (userField.value !== '' && passField.value !== '' && nameField.value) {
      const newAcc = new FormData();
      newAcc.append('auth', localStorage.getItem('token'));
      newAcc.append('u', userField.value);
      newAcc.append('p', passField.value);
      newAcc.append('n', nameField.value);
      newAcc.append('mode', 'createAcc');

      axios.post(config.HOMECAT_API, newAcc).then(output => {
        if (output.data.response.status === 'OK') {
          setSnackBarType('success');
          setSnackMsg('New account created successfully');
          nameField.value = '';
          userField.value = '';
          passField.value = '';
          setTrigger(prev => prev + 1);
        } else {
          setSnackBarType('error');
          setSnackMsg(
            'Something went wrong. Most likely username already exist'
          );
        }
      });
      setSnackOpen(true);
    } else {
      setSnackBarType('error');
      setSnackMsg('Please fill in all fields');
      setSnackOpen(true);
      return;
    }
  };

  const deleteHomeCat = id => {
    const data = new FormData();
    data.append('mode', 'deleteHomeCat');
    data.append('id', id);
    data.append('auth', localStorage.getItem('token'));

    // ASYNC METHOD
    axios.post(config.HOMECAT_API, data).then(output => {
      if (output.data.response.status === 'OK') {
        setTrigger(prev => prev + 1);
        setSnackBarType('success');
        setSnackMsg('Home Cat account deleted');
        setSnackOpen(true);
      }
    });
  };

  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackOpen(false);
  };

  return (
    <HomeCatLayout
      snackClose={snackClose}
      snackOpen={snackOpen}
      snackMsg={snackMsg}
      homecats={homecats}
      createNewAcc={createNewAcc}
      snackBarType={snackBarType}
      deleteHomeCat={deleteHomeCat}
    />
  );
};

export default HomeCats;
